<template>
     <v-container fluid>
         <v-card>
            <v-toolbar>
                <v-icon>cloud_download</v-icon>
                <v-toolbar-title class="font-weight-light">&nbsp;Alta de Gestión Masiva</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-btn text icon color="red" v-on="on" @click="setStatusTareaFrecuente(action)">
                    <v-icon v-if="action.esFrecuente">favorite</v-icon>
                    <v-icon v-else>favorite_border</v-icon>
                    </v-btn>
                </template>
                <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>  
                <span v-else>Agregar a Tareas Frecuentes</span>  
                </v-tooltip>
            </v-toolbar>
            <v-card-text>
                <v-row dense>
                    <v-col cols ="3">
                        <v-autocomplete v-model="filtro.empresaId" :items="listEmpresas" autocomplete="disabled"
                            item-text="nombre" item-value="id" label="Casos de la Empresa" placeholder="Seleccione una" :menu-props="{minWidth:'400'}"></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col >
                        <v-autocomplete :items="listaTiposGestion" v-model="filtro.tipoGestionId"
                                item-text="descripcion" item-value="id" label="Tipo de Gestión"></v-autocomplete>
                    </v-col>

                    <v-col >
                        <v-autocomplete :items="listaTareasFiltered" v-model="filtro.tareaId" no-data-text="Debe elegir el tipo de gestión"
                                item-text="descripcion" item-value="id" label="Tarea a asentar"></v-autocomplete>
                    </v-col>

                    <v-col >
                        <v-autocomplete :items="listaRespuestas" v-model="filtro.respuestaId" placeholder="Seleccione una" clearable
                                item-text="descripcion" item-value="id" label="Respuesta" loading="loadingRespuestas"></v-autocomplete>
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col >
                        <v-alert color="info" dark dense>
                        <div>
                            Tener en Cuenta. El archivo debe tener formato Excel, con 2 columnas (Columnas/Encabezados): 
                        </div>
                        <div>
                        A - 
                        <v-radio-group v-model="filtro.esDocumento" column :mandatory="true">
                         <v-radio :value='true' label="Documento"></v-radio>
                         <v-radio :value='false' label="Credito"></v-radio>
                        </v-radio-group>
                        </div>
                        <div>
                        B - Motivo
                        </div>                                               
                        </v-alert>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <v-file-input  
                            v-model="archivoFiltroOperaciones"
                            placeholder="Seleccione el archivo Excel con los Casos"
                            label="Archivo Filtro"
                            prepend-icon="mdi-paperclip">
                        </v-file-input>
                    </v-col>
                    <v-col cols="2">
                        <v-btn @click="traerListaOperacionesDeExcel()">
                            Comprobar Archivo
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row v-if="archivoFiltroOperaciones != null">
                    <v-col>
                    <v-chip v-if="filtro.listaNumeroCreditos == ''" label color="warning">
                        Presione Comprobar Archivo para procesarlo
                    </v-chip>
                    
                    <template v-else>
                        <div v-if="filtro.esDocumento" >
                            Hay {{filtro.listaNumeroCreditos.cantidad }} Documentos en el Archivo
                        </div>
                        <div v-else >
                            Hay {{filtro.listaNumeroCreditos.cantidad }} Créditos en el Archivo
                        </div>
                    </template>
                    </v-col>
                </v-row>
            
            </v-card-text>
            <v-card-actions>
                                
                <v-spacer></v-spacer>
                <v-btn dark  color="green" @click="procesar">
                    Generar Gestiones&nbsp;
                    <!-- <v-icon >cloud_download</v-icon>                   -->
                </v-btn>
            </v-card-actions>

         </v-card>

        <app-loading :loading="loading"></app-loading>

     </v-container>
</template>
<script>

import { http } from '@/axios'
import Vue from 'vue'
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex'

export default {
    data() {
        return {
            loading: false,
            loadingRespuestas: false,
            filtro: {empresaId: 1, tipoGestionId: 0, tareaId:0, respuestaId: 0, comentarios: '', fechaDesde: null, fechaHasta: null, listaNumeroCreditos: '', esDocumento : false},
            listEmpresas: [],
            listaRespuestas:[],
            listaTiposGestion:[],
            listaTareas:[],
            archivoFiltroOperaciones:[]
           
        }
    },
    async created() {
      this.loadEmpresas();
      
      this.loadTiposGestion();
      this.loadTareas();

      this.filtro.fechaDesde = this.$moment(new Date()).format('2005-01-01');
      this.filtro.fechaHasta = this.$moment(new Date()).format('YYYY-MM-DD');
    
    }, 
    computed: {
        ...mapGetters(['activeTask','getActionFromLink','user','closeRelatedTasks']),
        action: function(){
        return this.getActionFromLink(this.$route.path) 
        },
        listaTareasFiltered:function(){
            if(!this.listaTareas) return [];

            const listaTareasFiltrada = this.listaTareas.filter((e) => e.tipoGestionId == this.filtro.tipoGestionId);
      
            return listaTareasFiltrada;
        },
    },
    watch:{
        'filtro.tareaId': function(){
            this.loadRespuestas();
        },
    },
    methods: {
    ...mapMutations(["setActiveTask","alertClear", "alertSuccess", "alertWarning", "alertError"]),
    ...mapActions(['setStatusTareaFrecuente']),    
    async loadEmpresas(){
        this.loading = true;
        try{
            var result = await http.get('empresas/list/porusuario?usuarioId='+this.user.id);

            this.listEmpresas = result.list;
        }
        catch(error){
            // Error
            this.alertError(error)
        }
        this.loading = false;
    },
    async loadTiposGestion(){
      this.loading = true;
      try{
        var result = await http.get('tiposgestion');

        this.listaTiposGestion = result.list;
        
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadTareas(){
      this.loading = true;
      try{
        var result = await http.get('gestion/listtareasgestion');

        this.listaTareas = result.list;
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loading = false;
    },
    async loadRespuestas(){
      if(!this.filtro || !this.filtro.tareaId) return;
      
      this.loadingRespuestas = true;
      try{
        var result = await http.get('gestion/listrespuestastareagestion?tareaId=' + this.filtro.tareaId );

        this.listaRespuestas = result.list;

        if(this.listaRespuestas.length > 0)
            this.filtro.respuestaId = this.listaRespuestas[0].id; // selecciona la 1ra
      }
      catch(error){
        // Error
        this.alertError(error)
      }
      this.loadingRespuestas = false;
    },    
    async procesar(){
         // validaciones
        if(this.filtro.empresaId === 0) 
        {
            this.alertWarning('Debe seleccionar una Empresa.');
            return;
        }
        if(this.filtro.tareaId === 0) 
        {
            this.alertWarning('Debe seleccionar una Tarea.');
            return;
        }

        if(this.filtro.respuestaId === 0) 
        {
            this.alertWarning('Debe seleccionar una Respuesta.');
            return;
        }
        if(this.filtro.listaNumeroCreditos === '') 
        {
            this.alertWarning('No se ingresaron los casos a procesar o no comprobo los el archivo.');
            return;
        }
        
        let request = new FormData();  

        request.append('empresaId',this.filtro.empresaId);
        request.append('tipoGestionId',this.filtro.tipoGestionId);
        request.append('tareaId',this.filtro.tareaId);
        request.append('respuestaId',this.filtro.respuestaId);
        request.append('archivo',this.archivoFiltroOperaciones);
        request.append('porDocumento',this.filtro.esDocumento);     

        var self = this;

        try {
            self.loading = true;

            await http.post('gestion/altamasivapornumerocredito', request )
                .then(resp => {
                    console.log(resp);

                    if(resp.error ){
                        self.alertError(resp.error);
                    }
                    else{
                        self.alertSuccess('Proceso Completado');
                        this.archivoFiltroOperaciones = null;
                    }

                })
                .catch((e) => {
                    self.alertError(e)
                });
            
        } catch (error) {
            // Error
            self.alertError(error)
        }
        self.loading = false
    },
    async traerListaOperacionesDeExcel(){

      if(!this.archivoFiltroOperaciones || this.archivoFiltroOperaciones.length == 0) return;
      if(!this.archivoFiltroOperaciones.name.includes('.xls'))
      {
        this.archivoFiltroOperaciones = [];
        this.alertWarning('Debe elegir un archivo Excel.');
        return;
      }

      this.loading = true;
      let formData = new FormData();  

      formData.append('archivo',this.archivoFiltroOperaciones);
      formData.append('porDocumento',this.filtro.esDocumento);

      try{
        var listaOps = await http.post('archivosDebito/excelAFiltroOperaciones', formData);
        // console.log(listaOps);
        this.filtro.listaNumeroCreditos =listaOps;

        console.log(listaOps);

      } catch (error) {
          // Error
          this.alertError(error)
      }    
      
      this.loading = false;

    },

},
  
}
</script>